<template>
  <div id="box">
    <div class="headNav">
      <div class="headNav-title">会议室预约后台</div>
      <div class="headNav-content">{{username}}</div>
      <div class="headNav-btn">
        <div @click="dialogPaseword=true">修改密码</div>
        <div @click="remove">退出登录</div>
      </div>
    </div>
    <!-- <div class="box_t">
      <h3 class="title">会议室预约后台</h3>
      <div class="box_tl">
        {{username}}
      </div>

      <div class="btn">
        <div @click="dialogPaseword=true">修改密码</div>
        <div @click="remove">退出登录</div>
      </div>
    </div> -->
    <div id="back">
      <div id="box_c">
        <span class="box_c1">日期</span>
        <!-- <img class="box_c2" :src="Left" id="Left"> -->
        <!-- 左上角日期 -->
        <el-date-picker v-model="value8" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" align="center" @change="ferentlist"></el-date-picker>

        <!-- <span class="box_c3">{{newTime}}</span> -->
        <!-- <img class="box_c4" :src="Right" id="Right" alt> -->
        <span class="box_c5">
          会议室数量：
          <b style="color:#000;">{{meetingNum}}</b>
        </span>
        <el-button class="query-btn" @click="query">查询会议</el-button>
        <p class="box_c7">
          <!-- 新建会议室弹窗 -->

          <el-button style=" width:139px;height:36px;margin:0;box-sizing: border-box;color:#fff;" type="text" @click="compile2()">新建会议室</el-button>
          <el-dialog title="新建会议室" :visible.sync="dialogFormVisible1">
            <el-form :model="form">
              <div id="hint">
                <span class="hint_1">会议室名称：</span>
                <el-input v-model="establishName" clearable></el-input>
                <br />
                <span class="hint_2">容纳人数：</span>
                <el-input placeholder="请输入内容" v-model="establishNumber" clearable></el-input>
                <span class="hint_3">所属楼层：</span>
                <el-input class="hint_3in" placeholder="请输入" v-model="establishFloor" clearable></el-input>
                <br />
                <span class="hint_4">关联设备码：</span>
                <el-input v-model="establishCode" clearable></el-input>
                <br />

                <div style="margin-bottom:56px;">
                  <span class="hint_5">上传图片：</span>

                  <el-upload class="avatar-uploader" action="https://meeting.joncloudapp.com/upload/room" :show-file-list="false" :on-success="establishHandleAvatarSuccess" :before-upload="establishBeforeAvatarUpload">
                    <img v-if="establishImage" :src="establishImage" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <el-button @click="Newmak()" class="but">新建</el-button>
                <el-button @click="cencle()">取消</el-button>
              </div>
            </el-form>
          </el-dialog>
          <el-dialog title="编辑会议室" :visible.sync="dialogModifyMeeting">
            <el-form :model="form">
              <div id="hint">
                <span class="hint_1">会议室名称：</span>
                <el-input v-model="inputa" clearable></el-input>
                <br />
                <span class="hint_2">容纳人数：</span>
                <el-input placeholder="请输入内容" v-model="inputb" clearable></el-input>
                <span class="hint_3">所属楼层：</span>
                <el-input class="hint_3in" placeholder="请输入" v-model="inputc" clearable></el-input>
                <br />
                <span class="hint_4">关联设备码：</span>
                <el-input v-model="inputd" clearable></el-input>
                <br />

                <div style="margin-bottom:56px;">
                  <span class="hint_5">上传图片：</span>

                  <el-upload class="avatar-uploader" action="https://meeting.joncloudapp.com/upload/room" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <el-button @click="modifyMeeting()" class="but">保存</el-button>
                <el-button @click="dialogModifyMeeting=false">取消</el-button>
              </div>
            </el-form>
          </el-dialog>
          <el-dialog title="修改密码" :visible.sync="dialogPaseword" width="30%" class="modify-password" center>
            <el-form ref="ruleForm" label-width="100px" class="modify-box">
              <el-form-item label="旧密码">
                <el-input v-model="oldPassword" class="modify-input"></el-input>
              </el-form-item>
              <el-form-item label="新密码">
                <el-input v-model="newPassword" class="modify-input"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogPaseword = false">取 消</el-button>
              <el-button type="primary" @click="modify()">确 定</el-button>
            </span>
          </el-dialog>
          <!-- 
          <el-popover
            ref="popover4"
            v-model="visible4"
            placement="left"
            width="670"
            trigger="click"
          >
            <h2 class="pop-up">新建会议室</h2>
            <div id="hint">
              <span>会议室名称：</span>
              <el-input v-model="inputa" clearable></el-input>
              <br>
              <span style="margin-left:14px;">容纳人数：</span>
              <el-input style="margin-right:26px;" placeholder="请输入内容" v-model="inputb" clearable></el-input>
              <span class="hint_3">所属楼层：</span>
              <el-input placeholder="请输入" v-model="inputc" clearable></el-input>
              <br>
              <span>关联设备码：</span>
              <el-input v-model="inputd" clearable></el-input>
              <br>
             
               <div style="margin-bottom:56px;">
                <span class="hint_5">上传图片：</span>

                <el-upload
                  class="avatar-uploader"
                  action="http://112.74.162.44:8887/api/upload/uploadImage"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-button @click="Newmak()" class="but">新建</el-button>
              <el-button @click="cencle()">取消</el-button>
            </div>

        
          </el-popover>
          <span v-popover:popover4>
            新建会议室
            <img :src="yiou" id="yiou" alt>
          </span>-->
        </p>
      </div>
      <!-- 会议列表1 -->
      <div id="box_b">
        <h3>会议室列表</h3>
        <div id="box_b0">
          <div id="box_b1" v-for="(item,index) in arr" :key="index">
            <img class="b1_tu" :src="item.pic" alt />
            <span class="b1_0"></span>
            <span class="b1_1">{{item.name}}</span>
            <span class="b1_2">容纳人数：&nbsp;{{item.personCount}}</span>
            <span class="b1_3">所属楼层：{{item.floor}}层</span>
            <!-- 预约会议信息 -->

            <div class="kuang">
              <el-popover placement="top" offset="3" width="251" height="600" trigger="hover" v-for="(items,index) in item.reservationList" :key="index">
                <!-- <div > -->
                <p style="margin:0 0 10px 8px;">预约信息</p>
                <!-- <p style="margin:0 0 6px 8px;">会议室名称：{{ items.conferenceName}}</p> -->
                <p style="margin:0 0 6px 8px;">发起人：{{items.initiatorName}}</p>
                <p style="margin:0 0 6px 8px;">会议主题：{{items.theme}}</p>
                <p style="margin:0 0 6px 8px;">联系电话：{{items.phone}}</p>
                <p style="margin:0 0 6px 8px;">预约时间：{{items.start}}—{{items.end}}</p>
                <template v-if="nowTime < new Date(items.reservationDate.split('-').join('/') + ' ' + items.start).getTime()">
                  <el-button size="mini" type="text" style="margin:10px 0 8px 20px;width:100px;display:inline-block;" @click="onCancelReservation(items.id)">取消预约</el-button>
                  <el-button type="primary" size="mini" style="margin:10px 0 8px 20px;width:100px;display:inline-block;" @click="onModifyMessage(items.id,items)">编辑</el-button>
                </template>

                <!-- </div> -->
                <!-- {{new Date(yyyymmdd).getTime()}} {{nowTime}} -->
                <template v-if="nowTime < new Date(items.reservationDate.split('-').join('/') + ' ' + items.start).getTime()">
                  <el-button type="success" class="kuang-btn" slot="reference">{{items.start}}—{{items.end}}</el-button>
                </template>
                <template v-if="nowTime > new Date(items.reservationDate.split('-').join('/') + ' ' + items.start).getTime() &&nowTime < new Date(items.reservationDate.split('-').join('/') + ' ' + items.end).getTime()">
                  <el-button type="danger" class="kuang-btn" slot="reference">{{items.start}}—{{items.end}}</el-button>
                </template>
                <template v-if="nowTime > new Date(items.reservationDate.split('-').join('/') + ' ' + items.end).getTime()">
                  <el-button type="info" class="kuang-btn" slot="reference">{{ items.start}}—{{items.end}}</el-button>
                </template>
              </el-popover>
            </div>

            <!-- 预约会议弹窗 -->
            <div class="b1_4">
              <el-button type="text" class="buta" style="color:#fff;margin-right:10px;" @click="cencle5(item.id)">会议预约</el-button>
              <el-button type="text" style="color:#000; margin-right:10px;" class="buta" @click="onModify(item.id,item)">编辑</el-button>
              <el-button type="text" style="color:#000;" class="buta" @click="onDelete(item.id)">删除会议室</el-button>
              <el-dialog title="新建预约" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                  <el-form-item label="发起人姓名：" :label-width="formLabelWidth">
                    <el-input v-model="form1" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话：" :label-width="formLabelWidth">
                    <el-input placeholder="请输入11位手机号码" maxlength="11" v-model="form2" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="会议主题：" :label-width="formLabelWidth">
                    <el-input v-model="form3" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="与会人员：" :label-width="formLabelWidth">
                    <el-input v-model="form4" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="备   注：" :label-width="formLabelWidth">
                    <el-input v-model="form5" autocomplete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="预约时间：" :label-width="formLabelWidth">
                    <el-date-picker v-model="value12" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" align="center"></el-date-picker>
                  </el-form-item>
                  <span class="make1_1">起点时间：</span>
                  <el-time-select style="width:165px;height:33px;" placeholder="时" v-model="startTime" :picker-options="{
                                    start: '06:00',
                                    step: '00:5',
                                    end: '24:00'
                                  }"></el-time-select>
                  <span class="make1_2">终点时间：</span>
                  <el-time-select style="width:165px;height:33px;" placeholder="时" v-model="endTime" :picker-options="{
                                    start: '06:00',
                                    step: '00:5',
                                    end: '24:00',
                                    minTime: startTime
                                  }"></el-time-select>
                </el-form>
                <br />
                <div slot="footer" class="dialog-footer">
                  <el-button class="butt" @click="cencle1()">取 消</el-button>
                  <el-button class="butt1" type="primary" @click="Newconference()">确 定</el-button>
                </div>
              </el-dialog>
              <!-- 删除会议室 -->
              <el-dialog title="一旦删除，所有数据丢失" :visible.sync="centerDialogVisible" width="30%" center class="delete">
                <el-form ref="ruleForm" label-width="100px" class="password-box">
                  <el-form-item label="密码">
                    <el-input v-model="password" class="password-input" show-password placeholder="请输入密码"></el-input>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="centerDialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="deleteMeeting()">确 定</el-button>
                </span>
              </el-dialog>

              <!-- 修改预约 -->
              <el-dialog title="修改预约" :visible.sync="dialogFormVisibleModify">
                <el-form :model="form">
                  <el-form-item label="发起人姓名：" :label-width="formLabelWidth">
                    <el-input v-model="form1" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话：" :label-width="formLabelWidth">
                    <el-input placeholder="请输入11位手机号码" maxlength="11" v-model="form2" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="会议主题：" :label-width="formLabelWidth">
                    <el-input v-model="form3" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="与会人员：" :label-width="formLabelWidth">
                    <el-input v-model="form4" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="备   注：" :label-width="formLabelWidth">
                    <el-input v-model="form5" autocomplete="off"></el-input>
                  </el-form-item>

                  <el-form-item label="预约时间：" :label-width="formLabelWidth">
                    <el-date-picker v-model="value12" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" align="center"></el-date-picker>
                  </el-form-item>
                  <span class="make1_1">起点时间：</span>
                  <el-time-select style="width:165px;height:33px;" placeholder="时" v-model="startTime" :picker-options="{
                                    start: '06:00',
                                    step: '00:5',
                                    end: '24:00'
                                  }"></el-time-select>
                  <span class="make1_2">终点时间：</span>
                  <el-time-select style="width:165px;height:33px;" placeholder="时" v-model="endTime" :picker-options="{
                                    start: '06:00',
                                    step: '00:5',
                                    end: '24:00',
                                    minTime: startTime
                                  }"></el-time-select>
                </el-form>
                <br />
                <div slot="footer" class="dialog-footer">
                  <el-button class="butt" @click="closeModifyMessage">取 消</el-button>
                  <el-button class="butt1" type="primary" @click="ModifyMessage()">确 定</el-button>
                </div>
              </el-dialog>

              <!-- 取消预约 -->
              <el-dialog title="取消预约" :visible.sync="dialogCancelReservation" width="30%" center class="delete">
                <el-form ref="ruleForm" label-width="100px" class="password-box">
                  <el-form-item label="密码">
                    <el-input v-model="password" class="password-input" show-password placeholder="请输入密码"></el-input>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogCancelReservation = false">取 消</el-button>
                  <el-button type="primary" @click="cancelReservation()">确 定</el-button>
                </span>
              </el-dialog>
            </div>

            <!-- 编辑预约弹窗 -->
            <!-- <div class="b1_4">
              <el-button
                type="text"
                class="buta"
                style="color:#fff;margin-right:10px;"
                @click="cencle5(item.id)"
                
              >会议预约</el-button>
              <el-button  type="text" style="color:#000;"  class="buta"  @click="compile(item.id)">编辑</el-button>
              <el-dialog title="编辑预约" :visible.sync="dialogFormVisible2">
                <el-form :model="form">
                  <el-form-item label="发起人姓名：" :label-width="formLabelWidth">
                    <el-input v-model="form1" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话：" :label-width="formLabelWidth">
                    <el-input
                      placeholder="请输入11位手机号码"
                      maxlength="11"
                      v-model="form2"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="会议主题：" :label-width="formLabelWidth">
                    <el-input v-model="form3" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="与会人员：" :label-width="formLabelWidth">
                    <el-input v-model="form4" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="备   注：" :label-width="formLabelWidth">
                    <el-input v-model="form5" autocomplete="off"></el-input>
                  </el-form-item>

                  <h5 class="make1">
                    <b>预约时间</b>
                  </h5>
                  <span class="make1_1">起点时间：</span>
                  <el-time-select
                    style="width:165px;height:33px;"
                    placeholder="时"
                    v-model="startTime"
                    :picker-options="{
                                    start: '09:00',
                                    step: '00:1',
                                    end: '18:30'
                                  }"
                  ></el-time-select>
                  <span class="make1_2">终点时间：</span>
                  <el-time-select
                    style="width:165px;height:33px;"
                    placeholder="时"
                    v-model="endTime"
                    :picker-options="{
                                    start: '09:00',
                                    step: '00:1',
                                    end: '18:30',
                                    minTime: startTime
                                  }"
                  ></el-time-select>
                </el-form>
                <br>
                <div slot="footer" class="dialog-footer">
                  <el-button class="butt" @click="compilequ()">取 消</el-button>
                  <el-button class="butt1" type="primary" @click="Newconference()">确 定</el-button>
                </div>
              </el-dialog>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
// import router from '../router/router'
// import format from "../formatDate.js";

// let myDate = new Date();
// let newtime = format(myDate);

export default {
  data() {
    return {
      messageId: "",
      messageDate: "",
      establishName: "",
      establishNumber: "",
      establishFloor: "",
      establishCode: "",
      establishImage: "",
      establishImageUrl: "", //上传图片
      yyyymmdd:
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "/" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate()),
      nowTime: "",
      timer: null,
      contrastTime: "",
      password: "",
      oldPassword: "",
      newPassword: "",
      meetingNum: "",
      newTime: "",
      leth: "",
      dialogModifyMeeting: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      centerDialogVisible: false,
      dialogCancelReservation: false,
      dialogFormVisibleModify: false,
      dialogPaseword: false,
      form: {
        name: "",
        type: [],
      },
      newData: "",
      form1: "",
      form2: "",
      form3: "",
      form4: "",
      form5: "",
      formLabelWidth: "120px",
      formLabelWidth1: "120px",
      username: "", //用户名
      arr: [], //会议室列表渲染
      show: false,
      inputa: "",
      inputj: "",
      inputk: "",
      inputl: "",
      inputm: "",
      inputn: "",
      inputo: "",
      inputb: "",
      inputc: "",
      inputd: "",
      inputp: "",
      inputq: "",
      inputr: "",
      inputs: "",
      inputt: "",
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      imageUrl: "", //上传图片
      imag: "", //上传图片
      startTime: "",
      endTime: "",
      visible: false, //预约信息弹窗
      Left: require("../assets/images/Left@2x.png"),
      Right: require("../assets/images/Right@2x.png"),
      yiou: require("../assets/images/yiou@2x.png"),
      gb: require("../assets/images/gb.png"),
      you: require("../assets/images/you@2x.png"),
      you1: require("../assets/images/yiou@2x.png"),
      value12: this.$dateFormat(new Date(), "yyyy-mm-dd"),
      // newTime: newtime, //显示当前时间
      value8: this.$dateFormat(new Date(), "yyyy-mm-dd"), //当天日期
      numberValidateForm: {
        age: "",
      },
    };
  },
  filters: {
    splitPrice(val) {
      return val / 10000;
    },
  },
  methods: {
    //去查询
    query() {
      this.$router.push({
        path: "./query",
      });
    },

    //编辑预约
    redact(id) {
      console.log(this.id, "编辑");
      this.redid = id;

      //   if (this.value8 == undefined) {
      //   this.$message.error("请先选择左上角日期！");
      // } else{
      //  this.dialogFormVisible2 = true;
      // }
    },
    //新建会议室
    compile2(id) {
      if (!(this.meetingNum <= this.arr.length)) {
        this.redid = id;
        this.dialogFormVisible1 = true;
      } else {
        this.$confirm(
          "会议室已超过上限,请联系管理员修改 电话 13200000000",
          "提示",
          {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "warning",
          }
        )
          .then(() => {})
          .catch(() => {});
      }
    },

    //开启计时器
    startSetInter() {
      const timer = setInterval(() => {
        this.nowTime = new Date().getTime();
      }, 2000);

      this.timer = timer;
    },

    compile(id, item) {
      console.log(item);
      this.inputa = item.name;
      this.inputb = item.personCount;
      this.inputc = item.floor;
      this.inputd = item.deviceCode;
      this.imageUrl = item.pic;
      console.log(id, "当前会议室id");
      this.redid = id;
      this.dialogFormVisible1 = true;
    },

    onDelete(id) {
      this.redid = id;
      this.centerDialogVisible = true;
    },
    //删除会议室
    deleteMeeting() {
      this.centerDialogVisible = true;
      let account = window.sessionStorage.getItem("account");
      let sha512 = require("js-sha512").sha512;
      let password = this.password;

      this.$axios
        .post(
          "https://meeting.joncloudapp.com/api/meeting/deleteRoom?roomId=" +
            this.redid +
            "&pwd=" +
            sha512(account + password)
        )
        .then((res) => {
          console.log(this.redid);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.centerDialogVisible = false;
            this.ferentlist();
            window.location.reload(); // 强制刷新当前页面
          }
          if (res.data.code == 500) {
            this.$message.error(res.data.message);
          }
        });
    },

    // 编辑会议室
    // redactPile(id){

    //        console.log(id,'当前会议室id')
    //     this. dialogFormVisible3 = true;
    // },

    remove() {
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("account");
      this.$router.replace("/");
    },
    //修改密码
    modify() {
      let account = window.sessionStorage.getItem("account");
      var sha512 = require("js-sha512").sha512;
      let oldPwd = this.oldPassword;
      let newPwd = this.newPassword;

      this.$axios
        .post(
          "https://meeting.joncloudapp.com/api/customer/updatePwd?oldPwd=" +
            sha512(account + oldPwd) +
            "&newPwd=" +
            sha512(account + newPwd) +
            "&p=" +
            newPwd
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.dialogPaseword = false;
            this.remove();
          }
          if (res.data.code == 500) {
            this.$message.error(res.data.message);
          }
        });
    },

    compilequ() {
      this.dialogFormVisible2 = false;
      this.form1 = "";
      this.form2 = "";
      this.form3 = "";
      this.form4 = "";
      this.form5 = "";
      (this.startTime = ""), (this.endTime = "");
    },

    //取消
    cencle() {
      (this.dialogFormVisible1 = false), (this.inputa = "");
      this.inputb = "";
      this.inputc = "";
      this.inputd = "";
      this.imageUrl = "";
    },
    cencle1() {
      this.dialogFormVisible = false;
      this.form1 = "";
      this.form2 = "";
      this.form3 = "";
      this.form4 = "";
      this.form5 = "";
      (this.startTime = ""), (this.endTime = "");
    },
    cencle2() {
      this.visible2 = false;
    },
    cencle3() {
      this.visible3 = false;
    },
    cencle5(id) {
      // this.ferencelist();
      console.log(id, "llll");
      this.id = id;
      if (this.value8 == undefined) {
        this.$message.error("请先选择左上角日期！");
      } else {
        this.dialogFormVisible = true;
      }
    },

    //新建会议室请求接口
    Newmak() {
      var imag = this.imag;
      console.log(imag, "imag图片");
      console.log(this.redid, "ID");
      if (
        this.establishName === "" &&
        this.establishNumber === "" &&
        this.establishFloor === "" &&
        this.establishCode === "" &&
        this.establishImage === ""
      ) {
        this.$message.error("新建内容不能为空！");
      } else {
        this.$axios
          .post(
            "https://meeting.joncloudapp.com/api/meeting/createRoom?name=" +
              // "http://192.168.1.145:8887/api/conferenceRoom/addConferenceRoom?conferenceName=" +
              this.establishName +
              "&personCount=" +
              this.establishNumber +
              "&floor=" +
              this.establishFloor +
              "&deviceCode=" +
              this.establishCode +
              "&pic=" +
              this.establishImage

            // +"&uiId=" +
            // this.usid
          )
          .then((res) => {
            if (res.data.code == 500) {
              this.$message.error(res.data.message);
            }
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.cencle();
              this.ferentlist();
              window.location.reload(); // 强制刷新当前页面
              // this.arr.push(res.data.data);
            }
            if (res.data.code == 400) {
              this.$message.success(res.data.message);
            }
          });
      }
    },

    onModify(id, item) {
      console.log(item);
      this.inputa = item.name;
      this.inputb = item.personCount;
      this.inputc = item.floor;
      this.inputd = item.deviceCode;
      this.imageUrl = item.pic;
      console.log(id, "当前会议室id");
      this.redid = id;
      this.dialogModifyMeeting = true;
    },

    // 显示修改预约弹窗
    onModifyMessage(id, item) {
      console.log(id);
      this.id = item.id;
      this.redid = item.roomId;
      this.form1 = item.initiatorName;
      this.form2 = item.phone;
      this.form3 = item.theme;
      this.form4 = item.participant;
      this.form5 = item.remark;
      this.messageDate = item.reservationDate;
      this.startTime = item.start;
      this.endTime = item.end;
      this.dialogFormVisibleModify = true;
    },

    //关闭修改预约弹窗
    closeModifyMessage() {
      this.id = "";
      this.form1 = "";
      this.form2 = "";
      this.form3 = "";
      this.form4 = "";
      this.form5 = "";
      this.messageDate = "";
      this.startTime = "";
      this.endTime = "";
      this.dialogFormVisibleModify = false;
    },

    //修改预约会议接口
    ModifyMessage() {
      // this.ferencelist();
      if (!this.form1) {
        return this.$message.error("发起人姓名不能为空！");
      }
      if (!this.form3) {
        return this.$message.error("会议主题不能为空！");
      }
      if (!this.messageDate) {
        return this.$message.error("日期不能为空！");
      }
      if (!this.startTime) {
        return this.$message.error("起点时间不能为空！");
      }
      if (!this.endTime) {
        return this.$message.error("终点时间不能为空！");
      }
      this.$axios
        .post(
          "https://meeting.joncloudapp.com/api/meeting/reservation/updateReservation?initiatorName=" +
            // "http://192.168.1.145:8887/api/conferenceReservation/addconferenceReservation?initiatorName=" +
            this.form1 +
            "&roomId=" +
            this.redid +
            "&id=" +
            this.id +
            "&phone=" +
            this.form2 +
            "&theme=" +
            this.form3 +
            "&participant=" +
            this.form4 +
            "&remark=" +
            this.form5 +
            "&date=" +
            this.messageDate +
            "&startTime=" +
            this.startTime +
            "&endTime=" +
            this.endTime
        )
        .then((res) => {
          if (res.data.code == 500) {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
          if (res.data.code == 200) {
            // this.cencle1();
            this.$message({
              type: "success",
              message: "修改成功",
            });
            // this.cencle1();
            this.dialogFormVisibleModify = false;
            window.location.reload(); // 强制刷新当前页面
            this.ferentlist();
          }
          if (res.data.code == 400) {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });

      // }
    },

    //显示取消预约框
    onCancelReservation(id) {
      this.dialogCancelReservation = true;
      this.messageId = id;
    },

    //取消预约
    cancelReservation() {
      let account = window.sessionStorage.getItem("account");
      let sha512 = require("js-sha512").sha512;
      let password = this.password;
      this.$axios
        .post(
          "https://meeting.joncloudapp.com/api/meeting/reservation/cancelReservationV2?id=" +
            this.messageId +
            "&pwd=" +
            sha512(account + password)
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.dialogCancelReservation = false;
            this.ferentlist();
            window.location.reload(); // 强制刷新当前页面
          }
          if (res.data.code == 500) {
            this.$message.error(res.data.message);
          }
        });
    },

    //修改会议室请求接口
    modifyMeeting() {
      var imag = this.imageUrl;
      console.log(imag, "imag图片");
      console.log(this.redid, "ID");
      if (
        this.inputa === "" &&
        this.inputb === "" &&
        this.inputc === "" &&
        this.inputd === "" &&
        this.imag === ""
      ) {
        this.$message.error("新建内容不能为空！");
      } else {
        this.$axios
          .post(
            "https://meeting.joncloudapp.com/api/meeting/updateRoom?name=" +
              // "http://192.168.1.145:8887/api/conferenceRoom/addConferenceRoom?conferenceName=" +
              this.inputa +
              "&personCount=" +
              this.inputb +
              "&floor=" +
              this.inputc +
              "&deviceCode=" +
              this.inputd +
              "&pic=" +
              imag +
              "&id=" +
              this.redid

            // +"&uiId=" +
            // this.usid
          )
          .then((res) => {
            if (res.data.code == 500) {
              this.$message.error(res.data.message);
            }
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              // this.cencle();
              this.dialogModifyMeeting = false;
              this.ferentlist();
              window.location.reload(); // 强制刷新当前页面
            }
            if (res.data.code == 400) {
              this.$message.success(res.data.message);
            }
          });
      }
    },

    //新增预约会议接口
    Newconference() {
      console.log(this.id, "当前列表id");
      console.log(this.id, "当前预约信息id");
      console.log(this.value8);
      // this.ferencelist();
      if (!this.form1) {
        return this.$message.error("发起人姓名不能为空！");
      }
      if (!this.form3) {
        return this.$message.error("会议主题不能为空！");
      }
      if (!this.startTime) {
        return this.$message.error("起点时间不能为空！");
      }
      if (!this.endTime) {
        return this.$message.error("终点时间不能为空！");
      }
      this.$axios
        .post(
          "https://meeting.joncloudapp.com/api/meeting/reservation?initiatorName=" +
            // "http://192.168.1.145:8887/api/conferenceReservation/addconferenceReservation?initiatorName=" +
            this.form1 +
            "&roomId=" +
            this.id +
            "&phone=" +
            this.form2 +
            "&theme=" +
            this.form3 +
            "&participant=" +
            this.form4 +
            "&remark=" +
            this.form5 +
            "&date=" +
            this.value12 +
            "&startTime=" +
            this.startTime +
            "&endTime=" +
            this.endTime +
            "&type=" +
            1
        )
        .then((res) => {
          console.log(res, "预约会议接口");
          if (res.data.code == 500) {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
          if (res.data.code == 200) {
            this.cencle1();
            this.$message({
              type: "success",
              message: "新建会议室成功",
            });
            this.cencle1();
            this.dialogFormVisible = false;
            window.location.reload(); // 强制刷新当前页面
            this.ferentlist();
            console.log(res.data, "预约成功");
          }
          if (res.data.code == 400) {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });

      // }
    },

    //刷新当前页面

    refresh() {
      let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
      this.$router.push(NewPage);
      this.$router.go(-1);
    },
    // 预约会议室列表数据
    ferentlist() {
      console.log(this.usid, "用户id");
      this.$axios
        .get(
          "https://meeting.joncloudapp.com/api/meeting/list?date=" + this.value8
          // "http://192.168.1.145:8887/api/conferenceRoom/conferenceRoomList",
          // {
          //   uiId: this.usid
          // }
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.leth = this.arr.length;
            this.arr = res.data.data; //会议室列表
          }
          if (res.data.code == 1001) {
            this.$message.error(res.data.message);
            this.remove();
          }

          // this.arr.forEach( function(item){
          //     console.log(item.conferenceReservationList[i] ,'遍历数组')
          // })
        });
    },

    // 编辑预约信息
    //  redactEdit() {
    //     console.log(this.redid, "当前编辑id");

    //     console.log(this.value8,'value8')
    //     console.log(this.usid,'usid')
    //     console.log(this.id,'id')
    //     console.log(this.redid,'redid')
    //     this.$axios
    //       .get(
    //         "http://112.74.162.44:8887/api/conferenceReservation//EditConference",
    //         {
    //           initiatorName:this.form1,
    //           phone:this.form2,
    //           finishingYear: this.value8,
    //           tConferenceTheme: this.form3,
    //           participant: this.form4,
    //           appointmentStart:this.startTime,
    //           appointmentEnd:this.endTime,
    //           uiId: this.usid,
    //           conferenceId:this.id,
    //           types:1,
    //           id:this.redid,
    //         }
    //       )
    //       .then(res => {

    //         console.log(res,'预约编辑')
    //         // this.arr = res.data.data;

    //       });
    //   },
    // 编辑会议室信息
    //  redactEditNewmak() {
    //     console.log(this.redid, "当前编辑id");

    //     this.$axios
    //       .get(
    //         "http://112.74.162.44:8887/api/conferenceRoom/conferenceRoom/update",
    //         {

    //           conferenceName:this.inputa,
    //           subordinateFloor:this.inputb,
    //           galleryfulPerson: this.inputc,
    //           deviceCode: this.inputd,
    //           conferencePhotos:
    //         }
    //       )
    //       .then(res => {

    //         console.log(res,'会议室编辑')
    //         // this.arr = res.data.data;

    //       });
    //   },

    // 上传图片
    establishHandleAvatarSuccess(res, file) {
      this.establishImageUrl = URL.createObjectURL(file.raw);
      this.establishImage = res.data;
      console.log(file, "3333");
      console.log(this.establishImage, "3333");
      if (res.code == 200) {
        this.$message.success("图片上传成功");
      }
    },
    establishBeforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 上传图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.imag = res.data;
      console.log(file, "3333");
      console.log(this.imag, "3333");
      if (res.code == 200) {
        this.$message.success("图片上传成功");
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    onSubmit() {
      console.log("submit!", "0000000000000");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },

  created() {
    // this.Newmak();
    this.username = sessionStorage.getItem("userName"); //获取指定key本地存储的值
    this.meetingNum = sessionStorage.getItem("roomCount"); //会议室数量
    this.startSetInter();
    this.ferentlist();
  },

  mounted() {
    // this.Newmak();
  },
  beforeMount() {
    this.ferentlist();
  },
  updated() {
    // console.log(this.value8,'年月日')
  },
};
</script>
<style>
body {
  overflow-x: hidden;
}
.el-dialog {
  overflow-y: hidden;
}

.delete .el-dialog__body {
  height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}
.delete .el-dialog__body .password-box {
  width: 0;
  height: 0;
}
.delete .el-dialog__body .password-box .password-input {
  width: 360px;
}

.delete .el-dialog__footer .dialog-footer .el-button--default {
  margin-left: 0px;
}
.modify-password .el-dialog__body {
  height: 100px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}
.modify-password .el-dialog__body .modify-box {
  width: 0;
  height: 0;
}
.modify-password .el-dialog__body .modify-box .modify-input {
  width: 360px;
}

.modify-password .el-dialog__footer .dialog-footer .el-button--default {
  margin-left: 0px;
}
button {
  background: rgba(4, 195, 255, 1);
  border-radius: 5px;
}
.el-dialog__body {
  height: 452px;
}
.el-dialog__footer {
  position: relative;
}
.picker {
  margin-top: 15px;
}
.pop-up {
  width: 669px;
  height: 50px;
  box-sizing: border-box;
  line-height: 50px;
  background: rgba(248, 248, 248, 1);
  padding-left: 20px;
  position: relative;
  margin-bottom: 33px;
}
.pop-up img {
  width: 71px;
  height: 71px;
  position: absolute;
  top: -7;
  right: 0;
}
/* 上传图片样式 */
.avatar-uploader .el-upload {
  width: 180px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.butt {
  width: 122px;
  height: 36px;
  background: rgba(4, 195, 255, 1);
  border-radius: 18px;
  position: absolute;
  bottom: 20px;
  left: 68px;
}
.butt1 {
  position: absolute;
  bottom: 20px;
  right: 218px;
}
</style>

<style scoped lang="scss">
html {
  margin: 0;
  padding: 0;
  background: rgba(244, 246, 249, 1);
}
.el-dialog {
  box-shadow: 0 0 0;
}
.el-input__inner {
  width: 100px;
}

.kuang-btn {
  margin-left: 10px !important;
  margin-bottom: 10px !important;
  // width: 180px !important;
  padding: 10px ;
}
.but {
  background: rgba(4, 195, 255, 1);
  border-radius: 5px;
  color: rgba(255, 255, 255, 1);
}
.make1 {
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 22px;
  margin: 15px 0 17px 36px;
}
// 预约弹窗时间
.make1_1 {
  width: 65px;
  height: 18px;
  font-size: 13px;
  display: inline-block;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
  margin-left: 43px;
  margin-right: 11px;
}
.make1_2 {
  width: 65px;
  height: 18px;
  font-size: 13px;
  display: inline-block;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 18px;
  margin-left: 30px;
}
.but1 {
  margin-top: 30px;
  position: absolute;
  bottom: 41px;
  left: 38px;
  background: #04c3ff;
}
.but2 {
  margin-top: 30px;
  position: absolute;
  bottom: 41px;
  left: 250px;
}

.el-button {
  // width: 176px;
  height: 34px;
  line-height: 12px;
  margin-left: 88px;
  border-radius: 5px;
  border: 1px solid rgba(233, 239, 244, 1);
}
.el-upload {
  margin-bottom: 56px;
}

.el-form {
  width: 670px;
  height: 585px;
}
#hint {
  box-sizing: border-box;
  width: 670px;
  height: 468px;
  background: rgba(255, 255, 255, 1);
  padding-left: 52px;
  position: relative;
  .but {
    margin-left: 100px;
  }
  .el-input {
    width: 178px;
    height: 33px;
    display: inline-block;
    font-size: 12px;
    color: #fff;
    // opacity: 0.5;
    line-height: 33px;
    border-radius: 5px;
    margin-bottom: 26px;
    margin-left: 70px;
  }
  span {
    display: inline-block;
  }
  .hint_1 {
    position: absolute;
    top: 10px;
    left: 20px;
  }
  .hint_2 {
    position: absolute;
    top: 60px;
    left: 34px;
  }
  .hint_3 {
    position: absolute;
    top: 60px;
    left: 326px;
  }
  .hint_3in {
    margin-left: 113px;
  }
  .hint_4 {
    position: absolute;
    top: 120px;
    left: 22px;
  }
  .hint_5 {
    margin: 59px 15px 0 -15px;
    float: left;
    display: inline-block;
  }
}

#hint1 {
  height: 600px;
  .make {
    width: 669px;
    height: 50px;
    font-size: 18px;
    box-sizing: border-box;
    margin-bottom: 35px;
    background: rgba(248, 248, 248, 1);
    padding-left: 28px;
    line-height: 50px;
    font-weight: 500;
    color: #333;
  }

  span {
    font-size: 13px;
    color: #666;
    margin-left: 52px;
  }
  .el-input {
    width: 459px;
    height: 33px;
    margin-bottom: 25px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
  }

  .el-time-select {
    width: 459px;
    height: 33px;
  }
  // 弹窗时间
}

#hint2 {
  height: 600px;
  width: 500px;
  .make {
    width: 669px;
    height: 50px;
    font-size: 18px;
    box-sizing: border-box;
    margin-bottom: 35px;
    background: rgba(248, 248, 248, 1);
    padding-left: 28px;
    line-height: 50px;
    font-weight: 500;
    color: #333;
  }
  .make1 {
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    margin: 15px 0 30px 60px;
  }
  span {
    font-size: 13px;
    color: #666;
    margin-left: 52px;
  }
  .el-input {
    width: 459px;
    height: 33px;
    margin-bottom: 25px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
  }

  .el-time-select {
    width: 459px;
    height: 33px;
  }
  // 弹窗时间
  .make1_1 {
    width: 65px;
    height: 18px;
    font-size: 13px;
    display: inline-block;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 18px;
    margin-left: 60px;
    margin-right: 2px;
  }
  .make1_2 {
    width: 65px;
    height: 18px;
    font-size: 13px;
    display: inline-block;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 18px;
    margin-left: 30px;
  }
}
.btn {
  position: absolute;
  top: 20px;
  right: 25px;
  display: flex;
}
.btn div:first-child {
  margin-right: 20px;
}
#box {
  #back {
    width: 100%;
    height: 1050px;
    background: rgba(244, 246, 249, 1);
  }
  .headNav {
    display: flex;
    align-items: center;
    height: 64px;
    padding: 0 54px 0 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.03);
    .headNav-title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(27, 37, 58, 1);
      flex: 1;
    }
    .headNav-content {
      margin-right: 250px;
    }
    .headNav-btn {
      display: flex;
      align-items: center;
      :first-child {
        margin-right: 20px;
      }
    }
  }
  // 上面标题
  .box_t {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 64px;
    padding: 0 54px 0 40px;
    text-align: left;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.03);
    .title {
      float: left;
      width: 141px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(27, 37, 58, 1);
      line-height: 28px;
      margin-top: 18px;
    }
    .box_tl {
      float: right;
      width: 153px;
      height: 64px;
      text-align: left;
      line-height: 19px;
      margin-right: 100px;
      .tl1 {
        float: left;
        display: block;
        width: 34px;
        height: 34px;
        background: coral;
        border-radius: 20px;
        margin-top: 15px;
      }
      .tl2 {
        float: right;
        display: block;
        width: 109px;
        height: 19px;
        text-align: left;
        margin-top: 22px;
      }
    }
  }
  #box_c {
    width: 100%;
    height: 67px;
    padding-left: 30px;
    line-height: 67px;
    float: left;
    background: rgba(244, 246, 249, 1);
    position: relative;
    // text-align: center;
    .query-btn {
      width: 139px;
      height: 36px;
      margin: 0;
      box-sizing: border-box;
      color: #fff;
      background-color: #04c3ff;
      border-radius: 18px;
      position: absolute;
      right: 350px;
      top: 15px;
    }
    .box_c1 {
      width: 71px;
      height: 36px;
      line-height: 36px;
      float: left;
      margin-right: 26px;
      display: inline-block;
      text-align: center;
      margin-top: 15px;
      background: rgba(255, 255, 255, 1);
      border-radius: 11px;
      border: 1px solid rgba(222, 226, 236, 1);
    }
    .box_c2 {
      width: 36px;
      height: 36px;
      display: inline-block;
      position: absolute;
      left: 121px;
      top: 15px;
    }
    .box_c3 {
      width: 99px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(39, 49, 66, 1);
      line-height: 20px;
      text-align: center;
      position: absolute;
      left: 169px;
      top: 23px;
    }
    .box_c4 {
      width: 36px;
      height: 36px;
      position: absolute;
      left: 283px;
      top: 15px;
    }
    .box_c5 {
      width: 100px;
      height: 20px;
      color: #a4b9d2;
      font-size: 14px;
      position: absolute;
      top: 3px;
      right: 196px;
    }

    .box_c7 {
      width: 138px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      color: #fff;
      background: rgba(4, 195, 255, 1);
      border-radius: 18px;
      text-align: left;
      position: absolute;
      top: 16px;
      right: 48px;
      // span {
      //   position: absolute;
      //   top: 0px;
      //   right: 47px;
      // }
      img {
        width: 180px;
        height: auto;
      }
    }
  }
  #box_b {
    width: 98%;
    height: 919px;
    box-sizing: border-box;
    background: rgba(245, 249, 250, 1);
    box-shadow: 0px 0px 5px 0px rgba(232, 232, 232, 0.53);
    border-radius: 8px;
    float: left;
    margin: 0 20px 0 20px;
    background: #fff;
    padding: 69px 30px 0 30px;

    h3 {
      position: absolute;
      font-size: 16px;
      color: #273142;
      line-height: 22px;
      top: 161px;
      left: 50px;
      width: 80px;
      height: 22px;
    }
    // div {
    //   width: 1408px;
    //   height: 263px;
    //   margin-bottom: 15px;
    //   background: rgba(255, 255, 255, 1);
    //   box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.07);
    //   border-radius: 6px;
    //   border: 1px solid rgba(243, 243, 243, 1);

    // }
    //列表1
    #box_b0 {
      width: 98%;

      #box_b1 {
        width: 1413px;
        height: 263px;
        margin-bottom: 15px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.07);
        border-radius: 6px;
        border: 1px solid rgba(243, 243, 243, 1);
        position: relative;

        .b1_4y {
          width: 122px;
          height: 36px;
          background: rgba(4, 195, 255, 1);
          border-radius: 18px;
          text-align: left;
          line-height: 36px;
          position: absolute;
          top: 20px;
          right: 161px;
        }
        .you {
          width: 26px;
          height: 26px;
          position: absolute;
          top: 25px;
          right: 166px;
        }

        .b1_5 {
          width: 107px;
          height: 36px;
          font-size: 14px;
          line-height: 36px;
          text-align: center;
          background: rgba(4, 195, 255, 1);
          border-radius: 18px;
          opacity: 0.21;
          position: absolute;
          top: 20px;
          right: 38px;

          .you1 {
            width: 26px;
            height: 26px;
            background: rgba(52, 197, 248, 1);
            border-radius: 35px;
            position: absolute;
            top: 5px;
            right: 5px;
          }
        }

        .b1_5s {
          width: 28px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 19, 51, 1);
          line-height: 20px;
          position: absolute;
          top: 28px;
          right: 89px;
        }
        .kuang {
          width: 1330px;
          height: 88px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.01);
          border-radius: 11px;
          border: 1px solid rgba(243, 243, 243, 1);
          padding: 6px 6px 6px 0;
          position: absolute;
          bottom: 22px;
          left: 31px;
        }
        .b1_0 {
          width: 4px;
          height: 14px;
          background: rgba(4, 195, 255, 1);
          border-radius: 2px;
          position: absolute;
          top: 36px;
          left: 209px;
        }
        .b1_tu {
          width: 150px;
          height: 90px;
          // background: goldenrod;
          position: absolute;
          top: 33px;
          left: 39px;
        }
        .b1_1 {
          box-sizing: border-box;
          width: 150px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #273142;
          line-height: 22px;
          position: absolute;
          top: 33px;
          left: 225px;
        }
        .b1_2 {
          width: 85px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(116, 123, 134, 1);
          line-height: 17px;
          position: absolute;
          top: 65px;
          left: 225px;
        }
        .b1_3 {
          width: 87px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(116, 123, 134, 1);
          line-height: 17px;
          position: absolute;
          top: 65px;
          left: 330px;
        }
        .b1_4 {
          // width: 122px;
          // height: 36px;
          // font-size: 14px;
          // color: #fff;
          // line-height: 36px;
          // text-align: center;
          // background: rgba(4, 195, 255, 1);
          // border-radius: 18px;
          position: absolute;
          top: 40px;
          right: 34px;
          width: 390px;
          height: 99px;
          .buta {
            width: 122px;
            height: 36px;
            margin: 0;

            background: rgba(4, 195, 255, 1);
            border-radius: 18px;
          }
        }
      }
    }
  }
}
</style> 
